import React, { createContext, useContext, useState } from "react";

const INITIAL_STATE = {
  showNotification: (text: string, delay: number) => {},
  resetNotificationState: () => {},
  notificationState: {
    show: false,
    text: "",
    delay: 3000,
  },
};

const NotificationToastContext = createContext(INITIAL_STATE);

export const useNotificationToast = () => {
  const context = useContext(NotificationToastContext);
  if (context == undefined)
    throw new Error(
      "useNotificationToast must be used within NotificationToastProvider"
    );
  return context;
};

export const NotificationToastProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const [notificationState, setNotificationState] = useState({
    show: false,
    text: "",
    delay: 3000,
  });

  const showNotification = (text: string, delay: number) => {
    setNotificationState({
      show: true,
      text,
      delay,
    });
  };

  const resetNotification = () => {
    setNotificationState((prev) => {
      return {
        ...prev,
        show: false,
      };
    });
  };

  return (
    <NotificationToastContext.Provider
      value={{
        showNotification,
        resetNotificationState: resetNotification,
        notificationState,
      }}
    >
      {children}
    </NotificationToastContext.Provider>
  );
};
